import { Link } from 'react-router-dom';
import { resolveTitle } from '../components/chat/ConversationList';
import { useChat } from '../chat/ChatProvider';
import { filterSocialImConversations } from '../chat/socialImConversations';
import { normalizeMuteMode, shouldAlertUnread } from '../chat/muteHelpers';
import { useMiniChat } from './MiniChatProvider';

export default function MiniChatLauncher() {
  const { state, myMemberId } = useChat();
  const {
    launcherOpen,
    setLauncherOpen,
    openMiniChat,
    promoteFromOverflow,
    overflow,
    busy,
    error,
  } = useMiniChat();

  const socialConversations = filterSocialImConversations(state.conversations);
  const totalUnread = socialConversations.reduce((sum, c) => {
    if (!shouldAlertUnread(c)) return sum;
    return sum + (Number(c.unreadCount) || 0);
  }, 0);

  const recent = socialConversations.slice(0, 12);

  return (
    <div className="mini-chat-launcher">
      {launcherOpen ? (
        <div className="mini-chat-tray" role="dialog" aria-label="迷你聊天">
          <div className="mini-chat-tray__header">
            <strong>聊天</strong>
            <Link to="/chat" className="mini-chat-tray__link" onClick={() => setLauncherOpen(false)}>
              完整聊天
            </Link>
            <button type="button" onClick={() => setLauncherOpen(false)} aria-label="關閉">
              ×
            </button>
          </div>
          {error ? <div className="mini-chat-tray__error">{error}</div> : null}
          {overflow.length > 0 ? (
            <div className="mini-chat-tray__section">
              <div className="mini-chat-tray__label">更多對話</div>
              <ul>
                {overflow.map((cid) => {
                  const conv = state.conversations.find(
                    (c) => String(c.conversationId || c.id) === String(cid)
                  );
                  const title = conv
                    ? resolveTitle(conv, state.participantSummaries, myMemberId)
                    : `會話 ${cid}`;
                  return (
                    <li key={cid}>
                      <button
                        type="button"
                        disabled={busy}
                        onClick={() => promoteFromOverflow(cid)}
                      >
                        {title}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : null}
          <div className="mini-chat-tray__section">
            <div className="mini-chat-tray__label">最近會話</div>
            {recent.length === 0 ? (
              <p className="mini-chat-tray__empty">尚無會話，可至聯絡人發起私訊</p>
            ) : (
              <ul>
                {recent.map((conv) => {
                  const cid = String(conv.conversationId || conv.id);
                  const title = resolveTitle(conv, state.participantSummaries, myMemberId);
                  const unread = conv.unreadCount || 0;
                  return (
                    <li key={cid}>
                      <button
                        type="button"
                        disabled={busy}
                        onClick={() => openMiniChat({ conversationId: cid })}
                      >
                        <span>
                          {title}
                          {normalizeMuteMode(conv) === 'ALL'
                            ? ' ·全靜音'
                            : normalizeMuteMode(conv) === 'EXCEPT_MENTION'
                              ? ' ·靜音·@'
                              : ''}
                        </span>
                        {shouldAlertUnread(conv) ? (
                          <span className="mini-chat-badge">{unread > 99 ? '99+' : unread}</span>
                        ) : null}
                      </button>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
          <div className="mini-chat-tray__footer">
            <Link to="/chat/contacts" onClick={() => setLauncherOpen(false)}>
              聯絡人
            </Link>
            <Link to="/chat/search" onClick={() => setLauncherOpen(false)}>
              搜尋用戶
            </Link>
          </div>
        </div>
      ) : null}
      <button
        type="button"
        className="mini-chat-fab"
        onClick={() => setLauncherOpen((v) => !v)}
        aria-label="開啟迷你聊天"
      >
        聊
        {totalUnread > 0 ? (
          <span className="mini-chat-badge mini-chat-badge--fab">
            {totalUnread > 99 ? '99+' : totalUnread}
          </span>
        ) : null}
      </button>
    </div>
  );
}
